/* eslint-disable max-classes-per-file */
import { FilterLabelData, FilterValueData } from '@ftr/lists'

export class SetReportFilterStateAction {
  static readonly type = '[ReportFilter] Patch Report Filter Value State'

  constructor(
    public filterValues: FilterValueData,
    public filterLabels: FilterLabelData = {},
  ) {}
}

export class ClearReportFilterStateAction {
  static readonly type = '[ReportFilter] Clear Report Filter State'
}
